module.exports = __webpack_public_path__ + "img/vertical-logo.05ae2d4b.svg";